module.exports = __webpack_public_path__ + "img/rem2.04286ce1.jpg";